export const officeFilter = () => {
    return {
        office: null,
        loading: true,

        init() {
            const hash = window.location.hash.substring(1);
            if (hash) {
                const button = document.querySelector(`[data-filter="${hash}"]`);
                if (button) {
                    this.filterByOffice(hash, button);
                }
            } else {
                // Ensure everything is visible on initial load
                this.filterByOffice('all', document.querySelector('[data-filter="all"]'));
            }
            this.loading = false;
        },
    
        filter(event) {
            const office = event.target.dataset.filter;
            this.filterByOffice(office, event.target);
            if (office === 'all') {
                history.pushState("", document.title, window.location.pathname + window.location.search);
            } else {
                window.location.hash = office;
            }
        },
    
        filterByOffice(office, button) {
            this.office = office;
            
            // Update active state
            document.querySelectorAll('.c-team-filter__link').forEach(el => {
                el.classList.remove('active');
            });
            button?.classList.add('active');

            // Filter team cards
            requestAnimationFrame(() => {
                document.querySelectorAll('.c-team-card').forEach(card => {
                    const item = card.closest('.o-quad__item');
                    const isVisible = office === 'all' || card.classList.contains(office);
                    
                    // Hide content immediately if becoming invisible
                    if (!isVisible) {
                        item.querySelector('.c-team-card__content').style.visibility = 'hidden';
                    }
                    
                    item.classList.toggle('is-hidden', !isVisible);
                    
                    // Reset positions after transition
                    setTimeout(() => {
                        if (!isVisible) {
                            Object.assign(item.style, {
                                position: 'absolute',
                                width: '0',
                                height: '0'
                            });
                        } else {
                            Object.assign(item.style, {
                                position: 'relative',
                                width: '',
                                height: ''
                            });
                            item.querySelector('.c-team-card__content').style.visibility = '';
                        }
                    }, 200); // Match transition duration
                });

                // Hide empty sections
                document.querySelectorAll('.o-stack__item').forEach(section => {
                    const hasVisibleCards = Array.from(section.querySelectorAll('.o-quad__item'))
                        .some(item => !item.classList.contains('is-hidden'));
                    section.style.display = hasVisibleCards ? 'block' : 'none';
                });
            });
        }
    }
}